import React from 'react';
import PropTypes from 'prop-types';
import { EmptyState as EmptyStatePrimitive } from '../ui';

const EmptyState = ({
  title = 'No Data Available',
  description = 'There is no data to display right now. Please try again later.',
  icon,
  compact = false,
  className = ''
}) => {
  return (
    <EmptyStatePrimitive
      title={title}
      description={description}
      icon={icon}
      className={`${compact ? 'py-8' : 'py-12'} ${className}`.trim()}
    />
  );
};

EmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.node,
  compact: PropTypes.bool,
  className: PropTypes.string
};

export default EmptyState;
